import { createReducer } from 'lib/utilities.js';

const initialState = {
  stats: [],
  keywords: [],
  groups: [],
  final: [],
};

export default createReducer(initialState, {
  FETCH_CRM_RANKINGS_DATA_SUCCESS: (state, payload) => {
    return { ...state, final: payload };
  },

  // Failed states
  FETCH_CRM_RANKINGS_DATA_FAIL: (state, payload) => {
    return {
      stats: 'failed',
      keywords: ' failed',
      groups: 'failed',
    };
  },
});
